export interface CrewDto {
  readonly crewMemberId: number; // PK
  readonly personId: number;
  readonly businessPersonId: number;
  businessPerson?: BusinessPersonDto;
  emailAddress: string;
  firstName: string;
  lastName: string;
  middleName: string;
  suffix: string;
  initials: string;
  phoneCode: string;
  phoneNumber: string;
  crewMemberTypeRatings: CrewMemberTypeRating[];
}

export interface BusinessPersonDto {
  emailAddresses?: { emailAddress: string; isSelected?: boolean; isPrimary?: boolean }[];
}

export interface CrewMemberNamesAndIdsDto {
  readonly crewMemberId: number; // PK
  firstName: string;
  lastName: string;
}

export interface CrewMemberTypeRating {
  aircraftTypeRatingId: number;
  crewMemberTypeId: number;
  crewMemberTypeName: string;
  active: boolean;
  controlId?: number;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function instanceOfCrewDto(obj: any): obj is CrewDto {
  if (obj && typeof obj === 'object') {
    return 'crewMemberId' in obj;
  }

  return false;
}
